export const Wheel = [
  'The_Options_Playbook',
  'Investors.com',
  'From_An_Article',
  'Through_The_Mail',
  'blog',
  'From_A_Friend',
  'Investopedia',
  'Yahoo_Finance',
  'Other'
];
